'use strict';

var quickView = require('./quickView');

module.exports = {
    showQuickview: quickView.showQuickview,
    trapQuickviewFocus: quickView.trapQuickviewFocus,
    hideDialog: quickView.hideDialog,
    beforeUpdateAttribute: quickView.beforeUpdateAttribute,
    updateAttribute: quickView.updateAttribute,
    updateAddToCart: quickView.updateAddToCart,
    updateAvailability: quickView.updateAvailability,
    displaySelectedColorValueQuickView: quickView.displaySelectedColorValueQuickView,
    onModalShown: quickView.onModalShown
};
